 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLFRONTMATTER01 from '@/components/xhtml/Frontmatter01'
 import XHTMLFRONTMATTER02 from '@/components/xhtml/Frontmatter02'
 import XHTMLACKNOWELGEMENT from '@/components/xhtml/Acknowelgement'
 import XHTMLPART1 from '@/components/xhtml/Part1'
 import XHTMLCHAPTER1 from '@/components/xhtml/Chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/Chapter2'
 import XHTMLPART2 from '@/components/xhtml/Part2'
 import XHTMLCHAPTER3 from '@/components/xhtml/Chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/Chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/Chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/Chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/Chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/Chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/Chapter9'
 import XHTMLPART3 from '@/components/xhtml/Part3'
 import XHTMLCHAPTER10 from '@/components/xhtml/Chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/Chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/Chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/Chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/Chapter14'
 import XHTMLPART4 from '@/components/xhtml/Part4'
 import XHTMLCHAPTER15 from '@/components/xhtml/Chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/Chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/Chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/Chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/Chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/Chapter20'
 import XHTMLCHAPTER21 from '@/components/xhtml/Chapter21'
 import XHTMLBIBILIOGRAPHY from '@/components/xhtml/Bibiliography'
 import XHTMLINDEX from '@/components/xhtml/Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Frontmatter01",
 			"name" : "xhtml/Frontmatter01",
 			"component" : XHTMLFRONTMATTER01
 		},
 		{
 			"path" : "/xhtml/Frontmatter02",
 			"name" : "xhtml/Frontmatter02",
 			"component" : XHTMLFRONTMATTER02
 		},
 		{
 			"path" : "/xhtml/Acknowelgement",
 			"name" : "xhtml/Acknowelgement",
 			"component" : XHTMLACKNOWELGEMENT
 		},
 		{
 			"path" : "/xhtml/Part1",
 			"name" : "xhtml/Part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/Chapter1",
 			"name" : "xhtml/Chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/Chapter2",
 			"name" : "xhtml/Chapter2",
 			"component" : XHTMLCHAPTER2
 		},
 		{
 			"path" : "/xhtml/Part2",
 			"name" : "xhtml/Part2",
 			"component" : XHTMLPART2
 		},
 		{
 			"path" : "/xhtml/Chapter3",
 			"name" : "xhtml/Chapter3",
 			"component" : XHTMLCHAPTER3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js